import React from 'react';
import { createPortal } from 'react-dom';

const XP_SOURCES = [
    { action: 'Лайк открытки', xp: '+5 XP', limit: '' },
    { action: 'Отправить открытку', xp: '+5 XP', limit: '' },
    { action: 'Открытку приняли', xp: '+20 XP', limit: '' },
];

const LevelInfoPopup = ({ level, currentXp, xpForNext, onClose }) => {
    const xpPercent = xpForNext > 0 ? Math.round((currentXp / xpForNext) * 100) : 0;
    const xpRemaining = xpForNext - currentXp;

    return createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center" onClick={onClose}>
            <div className="absolute inset-0 bg-black/40" />
            <div
                className="relative bg-white dark:bg-gray-800 rounded-2xl p-5 mx-4 max-w-[320px] w-full shadow-2xl animate-fade-in"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Уровень */}
                <div className="flex items-center gap-3 mb-4">
                    <div className="w-14 h-14 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-lg">
                        <span className="text-2xl font-black text-white">{level}</span>
                    </div>
                    <div>
                        <div className="text-lg font-bold text-gray-900 dark:text-gray-100">Уровень {level}</div>
                        <div className="text-xs text-gray-500 dark:text-gray-400">
                            {xpRemaining > 0 ? `Ещё ${xpRemaining} XP до уровня ${level + 1}` : 'Максимальный уровень'}
                        </div>
                    </div>
                </div>

                {/* Прогресс-бар */}
                <div className="mb-4">
                    <div className="flex justify-between text-xs text-gray-500 dark:text-gray-400 mb-1">
                        <span>{currentXp} XP</span>
                        <span>{xpForNext} XP</span>
                    </div>
                    <div className="w-full h-2.5 bg-gray-200 dark:bg-gray-600 rounded-full overflow-hidden">
                        <div
                            className="h-full bg-gradient-to-r from-amber-400 to-orange-500 rounded-full transition-all"
                            style={{ width: `${xpPercent}%` }}
                        />
                    </div>
                    <div className="text-center text-xs text-gray-400 dark:text-gray-500 mt-1">{xpPercent}%</div>
                </div>

                {/* Как заработать XP */}
                <div className="mb-3">
                    <div className="text-xs font-semibold text-gray-600 dark:text-gray-300 mb-2">Как заработать XP:</div>
                    <div className="space-y-1.5">
                        {XP_SOURCES.map((s, i) => (
                            <div key={i} className="flex items-center justify-between text-xs">
                                <span className="text-gray-600 dark:text-gray-400">{s.action}</span>
                                <div className="flex items-center gap-2">
                                    <span className="font-semibold text-amber-600 dark:text-amber-400">{s.xp}</span>
                                    {s.limit && <span className="text-gray-400 dark:text-gray-500 text-[10px]">({s.limit})</span>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Кнопка закрыть */}
                <button
                    onClick={onClose}
                    className="w-full py-2 text-sm font-semibold rounded-xl text-blue-500 dark:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700/50 transition-colors"
                >
                    Понятно
                </button>
            </div>
        </div>,
        document.body
    );
};

export default LevelInfoPopup;
